import {
  BlogComponentBlogItemDiv,
  BlogComponentBlogsDiv,
} from "../../styles/blogcomponentstyles/blocomponentstyles";
import {
  BlogNewsComponentMainDiv,
  BlogNewsComponentNewsDiv,
} from "../../styles/blognewsxomponentsstyles/blognewscomponentstyles";
import Footer from "../reusable/footer/footer";
import HeaderComponent from "../reusable/header/header";
import Logo from "./assets/bugzi logo 2.png";
import { ReactComponent as BackIcon } from "./assets/arrow-left-solid-full.svg";
const BlogNewsComponent = () => {
  return (
    <BlogNewsComponentMainDiv>
      <div className="header-holder">
        <HeaderComponent />
      </div>
      <BlogNewsComponentNewsDiv>
        <div>
          <div className="blognews-contaner">
            <div className="blognews-header-container">
              <div className="blognews-title-header-container">
                <div className="blognews-text-header-container">
                  <div className="blognews-back-container">
                    <a href="/blog" className="blognews-back-wrapper">
                      <div className="blognews-back-icon-wrapper">
                        <div className="blognews-back-icon-container">
                          <BackIcon />
                        </div>
                        <div className="blognews-back-icon-container ">
                          <BackIcon />
                        </div>
                      </div>
                      <div className="blognews-title-text-container">
                        <p>Back</p>
                      </div>
                    </a>
                    <div className="blognews-contrast-title-text-container ">
                      <p> Finance </p>
                    </div>
                  </div>
                  <div className="blognews-title-text-container">
                    <p>Oct 10, 2024</p>
                  </div>
                </div>
                <div>
                  <div className="blognews-title-text-container ">
                    <h1>Building Long-Lasting Customer in SaaS</h1>
                  </div>
                </div>
              </div>
              <div>
                <div className="blognews-image-container ">
                  <img src={Logo} alt="" />
                </div>
              </div>
            </div>
            <div className="blognews-news-body">
              <div className="blognews-news-container">
                <div>
                  <p>
                    Using SaaS for financial management brings a range of
                    benefits. From real-time data insights to enhanced security
                    and easy scalability, SaaS tools are designed to support
                    financial accuracy and business agility. Here are a few
                    specific benefits.
                  </p>
                </div>
                <ul>
                  <li>
                    Cost Efficiency: "No large upfront costs and lower
                    maintenance expenses."
                  </li>
                  <li>
                    Cost Efficiency: "No large upfront costs and lower
                    maintenance expenses."
                  </li>
                  <li>
                    Cost Efficiency: "No large upfront costs and lower
                    maintenance expenses."
                  </li>
                </ul>

                <div>
                  <h3> Key Benefits of SaaS for Businesses</h3>
                </div>
                <div>
                  <p>
                    Integrating SaaS solutions effectively requires strategic
                    planning. Begin by identifying your business needs,
                    selecting solutions that integrate well with your existing
                    tools, and training your team to maximize the software’s
                    potential. Here’s a quick checklist to help guide your
                    implementation.
                  </p>
                </div>
                <ul>
                  <li>
                    Cost Efficiency: "No large upfront costs and lower
                    maintenance expenses."
                  </li>
                  <li>
                    Cost Efficiency: "No large upfront costs and lower
                    maintenance expenses."
                  </li>
                  <li>
                    Cost Efficiency: "No large upfront costs and lower
                    maintenance expenses."
                  </li>
                </ul>
                  <div>
                  <p>
                    Integrating SaaS solutions effectively requires strategic
                    planning. Begin by identifying your business needs,
                    selecting solutions that integrate well with your existing
                    tools, and training your team to maximize the software’s
                    potential. Here’s a quick checklist to help guide your
                    implementation.
                  </p>
                </div>
              </div>
              <div className="blognews-news-share-container">
                <div>
                  <p>Share Blog

 </p>
                </div>
                <div className="blognews-share-icon-container">
                  <div className="blognews-share-icon">
                    <BackIcon/>
                  </div>
                   <div className="blognews-share-icon">
                    <BackIcon/>
                  </div> <div className="blognews-share-icon">
                    <BackIcon/>
                  </div>
                </div>
                
              </div>
              
            </div>
          </div>
        </div>
      </BlogNewsComponentNewsDiv>
      <BlogComponentBlogsDiv>
        <div>
          <div className="blogs-container">
            <div>
              <div>
                <h2>Related blogs</h2>
              </div>
            </div>
            <div>
              <div className="blogs-wrapper">
                {data.map((item, index) => (
                  <BlogComponentBlogItemDiv>
                    <div>
                      <a
                        className="blog-item-link-container"
                        href="/blogs/banddd"
                      >
                        <div className="blog-item-img-container">
                          <img alt="" src={Logo} />
                        </div>
                        <div className="blog-item-text-container">
                          <div className="blog-item-topic-text-container">
                            <div className="blog-topic-text-wrapper">
                              <p>SaaS</p>
                            </div>
                            <div>
                              <div className="blog-item-text-wrapper">
                                <p> Mar 13, 2025</p>
                              </div>
                            </div>
                          </div>
                          <div className="blog-item-text-wrapper ">
                            <h3>
                              Maximizing Your ROI with Effective SaaS Solutions
                            </h3>
                          </div>
                        </div>
                      </a>
                    </div>
                  </BlogComponentBlogItemDiv>
                ))}
              </div>
            </div>
          </div>
        </div>
      </BlogComponentBlogsDiv>
      <Footer />
    </BlogNewsComponentMainDiv>
  );
};

const data = ["", "", ""];
export default BlogNewsComponent;
